module.exports = __webpack_public_path__ + "img/Best-Wigs-for-Cancer-Patients.18ea69ec.jpg";